module.exports = __webpack_public_path__ + "img/avatar0.5ae81855.png";